<template>
  <v-container fluid class="pa-2 pa-md-6">
    <v-form ref="form" v-model="valid" lazy-validation :disabled="formularioBloqueado">
      <v-row>
        <v-col cols="12">
          <v-card class="pa-4">
            <v-card-title class="text-h6 text-md-h5 pb-2">
              {{ isEdit ? 'Editar ficha de trazabilidad' : 'Ficha de trazabilidad' }}
            </v-card-title>

            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    :items="articles"
                    item-text="Name"
                    item-value="Id"
                    v-model="form.articleId"
                    label="Artículo a elaborar"
                    prepend-icon="mdi-cube-outline"
                    :rules="[v => !!v || 'Requerido']"
                    clearable
                    @change="onArticleChange"
                    :filter="customArticleFilter"
                    no-data-text="No hay artículos"
                    hide-no-data
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                    :items="people"
                    item-text="Name"
                    item-value="Id"
                    v-model="form.operatorId"
                    label="Persona que rellena"
                    prepend-icon="mdi-account"
                    :rules="[v=>!!v || 'Requerido']"
                    clearable
                    no-data-text="No se encontraron personas"
                    :filter="filterPeople"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="form.batch"
                    label="Lote final"
                    prepend-icon="mdi-pound"
                    hint="Ej.: 2025-09-24-A"
                    persistent-hint
                    :rules="[v => !!v || 'El lote final es obligatorio']"
                  />
                </v-col>

                <v-col cols="12" md="4">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.date"
                        label="Fecha de elaboración"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[v=>!!v || 'Requerido']"
                      />
                    </template>
                    <v-date-picker v-model="form.date" @input="menu=false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="form.totalQty"
                    label="Cantidad total encajada"
                    prepend-icon="mdi-scale-balance"
                    type="number"
                    inputmode="decimal"
                    hint="Ej.: 10 tartas / 5000 g"
                    persistent-hint
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12">
          <v-card class="pa-4">
            <v-card-title class="text-h6 text-md-h5 pb-2">Ingredientes</v-card-title>

            <v-card-text>
              <div v-if="loadingIngredients" class="text-subtitle-2 grey--text">
                Cargando ingredientes…
              </div>

              <div v-else>
                <v-alert v-if="!ingredients.length" type="info" outlined>
                  Selecciona un artículo para ver su desglose de ingredientes.
                </v-alert>

                <v-simple-table v-else class="rounded-xl elevation-1">
                  <thead>
                    <tr>
                      <th class="text-left">Ingrediente</th>
                      <th class="text-right">Cant. receta 1UD</th>
                      <th class="text-center">Unidad</th>
                      <th class="text-right" style="min-width:120px">Cant. usada</th>
                      <th class="text-left" style="min-width:140px">Lote</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="ing in ingredients" :key="ing.Id">
                      <td class="font-weight-medium">{{ ing.Name }}</td>

                      <td class="text-right">
                        {{ formatNumber(ing.RecipeQty) }}
                      </td>

                      <td class="text-center">
                        {{ ing.UnidadPrincipal }}
                      </td>

                      <td class="text-right">
                        <v-text-field
                          v-model.number="ing.UsedQty"
                          type="number"
                          inputmode="decimal"
                          hide-details
                          dense
                          class="mb-0"
                          :step="ing.Step || '0.01'"
                          :min="0"
                        />
                      </td>

                      <td>
                        <v-text-field
                          v-model="ing.Batch"
                          placeholder="Lote proveedor"
                          hide-details
                          dense
                          class="mb-0"
                        />
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <v-divider class="my-4"></v-divider>

                <v-row>
                  <v-col cols="12" class="text-sm-right">
                    <div class="text-subtitle-1">Ingredientes con lote sin informar</div>
                    <div
                      class="text-h6"
                      :class="{ 'red--text': missingLots > 0, 'green--text': missingLots === 0 }"
                    >
                      {{ missingLots }}
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-3 action-buttons" dense>
        <v-col cols="12" md="4">
          <v-btn
            v-if="Number(perId) !== 56458"
            block
            class="trace-btn"
            color="primary"
            @click="prefillRecipeQty"
            :disabled="!ingredients.length || formularioBloqueado"
          >
            Rellenar cantidades vacías
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12">
          <v-card class="pa-4">
            <v-card-title class="text-h6 text-md-h5 pb-2">
              Datos finales de elaboración
            </v-card-title>

            <v-card-text>
              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="text-subtitle-2 mb-2">
                    Montadas de nata 1 ({{ form.montadasNataUno || 0 }})
                  </div>

                  <div class="check-bar">
                    <div
                      v-for="n in 20"
                      :key="'nata1-' + n"
                      class="check-item"
                      :class="{ active: n <= (form.montadasNataUno || 0) }"
                      @click="form.montadasNataUno === n ? form.montadasNataUno = 0 : form.montadasNataUno = n"
                    >
                      {{ n }}
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="text-subtitle-2 mb-2">
                    Montadas de nata 2 ({{ form.montadasNataDos || 0 }})
                  </div>

                  <div class="check-bar">
                    <div
                      v-for="n in 20"
                      :key="'nata2-' + n"
                      class="check-item"
                      :class="{ active: n <= (form.montadasNataDos || 0) }"
                      @click="form.montadasNataDos === n ? form.montadasNataDos = 0 : form.montadasNataDos = n"
                    >
                      {{ n }}
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.masadas"
                    label="Masadas"
                    prepend-icon="mdi-text"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="form.plastones"
                    label="Plastones"
                    prepend-icon="mdi-text"
                  />
                </v-col>

                <v-col cols="12">
                  <v-card class="pa-4 mt-2" outlined>
                    <v-card-title class="text-h6 pb-2">
                      Control de polares y aceite
                    </v-card-title>

                    <v-card-text>
                      <v-simple-table class="rounded-xl elevation-1">
                        <thead>
                          <tr>
                            <th class="text-left">Zona</th>
                            <th class="text-right">Polares inicio</th>
                            <th class="text-right">Polares final</th>
                            <th class="text-center">Cambio aceite</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="ctrl in controles" :key="ctrl.fila">
                            <td class="font-weight-medium">{{ ctrl.fila }}</td>

                            <td>
                              <v-text-field
                                v-model.number="ctrl.polaresInicio"
                                type="number"
                                inputmode="decimal"
                                dense
                                hide-details
                                class="mb-0"
                                step="0.01"
                                min="0"
                                @blur="comprobarPolares(ctrl.polaresInicio)"
                              />
                            </td>

                            <td>
                              <v-text-field
                                v-model.number="ctrl.polaresFinal"
                                type="number"
                                inputmode="decimal"
                                dense
                                hide-details
                                class="mb-0"
                                step="0.01"
                                min="0"
                                @blur="comprobarPolares(ctrl.polaresFinal)"  
                              />
                            </td>

                            <td class="text-center">
                              <v-checkbox
                                v-model="ctrl.cambioAceite"
                                dense
                                hide-details
                                class="ma-0 pa-0 d-inline-flex"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="form.notes"
                    auto-grow
                    label="Observaciones (opcional)"
                    prepend-icon="mdi-note-text"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-sheet class="py-3 px-2 px-md-6 sticky-footer">
            <v-row>
              <v-col cols="12" md="3" v-if="!formularioBloqueado">
                <v-btn
                  block
                  class="btn-lg"
                  color="primary"
                  @click="onSubmit('EN_CURSO')"
                  :disabled="submitting"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar en curso
                </v-btn>
              </v-col>

              <v-col cols="12" md="3" v-if="!formularioBloqueado">
                <v-btn
                  block
                  class="btn-lg"
                  color="success"
                  @click="onSubmit('FINALIZADO')"
                  :disabled="submitting"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  Finalizar
                </v-btn>
              </v-col>
              <v-col cols="12" md="3" v-if="!formularioBloqueado">
               
                <v-btn
                  v-if="(Number(perId) === 10634 || Number(perId) === 3 || Number(perId) === 56487 || Number(perId) === 56458) && this.form.estado !== 'ARCHIVADO'"
                  block
                  class="btn-lg"
                  outlined
                  color="green"
                  title="Archivar trazabilidad"
                  @click="validarItem(item)"
                >    
                  <v-icon>mdi-check-decagram</v-icon>
                  Archivar
                </v-btn>

              </v-col>
              <v-col cols="12" md="3">
                <v-btn
                  block
                  class="btn-lg"
                  outlined
                  color="grey darken-1"
                  @click="onExit"
                  :disabled="submitting"
                >
                  <v-icon left>mdi-arrow-left</v-icon>
                  Salir
                </v-btn>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-form>

    <!-- Diálogo de confirmación (mock) -->
    <v-dialog v-model="dialog" max-width="520">
      <v-card>
        <v-card-title class="text-h6">Trazabilidad guardada</v-card-title>
        <v-card-text>
          <div class="mb-2">Se ha simulado el guardado con los siguientes datos:</div>
          <pre class="payload-pre">{{ lastPayload }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog=false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPolares" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Aviso
        </v-card-title>

        <v-card-text>
          El valor de polares está cerca del límite permitido, informa al responsable de producción.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="dialogPolares = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>
import axios from "axios";
import TraceabilityService from "../store/modules/ZTrazabilidadObrador";
import { mapState } from "vuex";
//import axios from "axios"

export default {
  name: "TraceabilityForm",
  data: () => ({
    valid: true,
    menu: false,
    submitting: false,
    loadingIngredients: false,
    loadingTraceability: false,
    dialog: false,
    lastPayload: null,
    articles: [],
    divisions: [],
    people: [],
    ingredients: [],
    dialogPolares: false,
    form: {
      divisionId: null,
      articleId: null,
      operatorId: null,
      operatorId2: null,
      batch: "",
      date: new Date().toISOString().substr(0, 10),
      totalQty: null,
      notes: "",
      montadasNataUno: 0,
      montadasNataDos: 0,
      masadas: "",
      plastones: "",
      polares: "",
      //balsa 1 balsa 2 freidora en continuo
      estado: "EN_CURSO",
      controles: [
        {
          fila: "Freidora en continuo",
          polaresInicio: null,
          polaresFinal: null,
          cambioAceite: false
        },
        {
          fila: "Balsa 1",
          polaresInicio: null,
          polaresFinal: null,
          cambioAceite: false
        },
        {
          fila: "Balsa 2",
          polaresInicio: null,
          polaresFinal: null,
          cambioAceite: false
        }
      ],
    },
  }),
  computed: {
    ...mapState(['empId', 'perId', 'perAux', 'esEmpleado', 'urlRaiz']),

    isArchivado() {
      return this.form.estado === "ARCHIVADO";
    },

      usuariosPuedeEditarFinalizada() {
        return [56487, 56458, 3, 10634]; // Sergio y Carmen, javier celia
      },

      puedeEditarFinalizada() {
        return this.usuariosPuedeEditarFinalizada.includes(Number(this.perId));
      },

      isFinalizado() {
        return this.form.estado === "FINALIZADO";
      },

      formularioBloqueado() {
        return this.isArchivado || (this.isFinalizado && !this.puedeEditarFinalizada);
      },

    mainUnit() {
      const u = this.ingredients.map(i => i.Unit).filter(Boolean);
      if (!u.length) return "";
      const grams = u.every(x => ["g", "kg"].includes(x));
      return grams ? "g" : u[0];
    },
    totalUsed() {
      return this.ingredients.reduce((acc, i) => acc + (Number(i.UsedQty) || 0), 0);
    },
    missingLots() {
      return this.ingredients.filter(i => !i.Batch || !i.Batch.trim()).length;
    },
    isEdit() {
      return !!this.$route.query.id;
    },
    traceabilityId() {
      return this.$route.query.id;
    }
  },
  methods: {

    auth() {
      const t = localStorage.getItem("token");
      return { Authorization: t };
    },
    validarItem() {
      if (!confirm("¿Seguro que quieres marcar esta trazabilidad como archivada?")) {
        return;
      }

      this.loading = true;

      axios.post(
        `${this.urlRaiz}/api/ztrazabilidadobrador/changeStatus`,
        {
          trazabilidadObradorId: this.$route.query.id,
          estado: "ARCHIVADO"
        },
        {
          headers: this.auth()
        }
      )
      .then(() => {
        this.toast("Trazabilidad validada correctamente");
        this.loadData();
      })
      .catch(() => {
        this.toast("Error al archivar la trazabilidad", "error");
      })
      .finally(() => {
        this.loading = false;
        this.$router.push({ name: "TrazabilidadObradorListado" });
      });
    },

    filterPeople(item, queryText, itemText) {
      const text = (itemText || "").toLowerCase();
      const query = (queryText || "").toLowerCase().trim();

      if (!query) return true;

      return text.includes(query);
    },

    resetControles() {
      this.controles = [
        {
          fila: "Freidora en continuo",
          polaresInicio: null,
          polaresFinal: null,
          cambioAceite: false
        },
        {
          fila: "Balsa 1",
          polaresInicio: null,
          polaresFinal: null,
          cambioAceite: false
        },
        {
          fila: "Balsa 2",
          polaresInicio: null,
          polaresFinal: null,
          cambioAceite: false
        }
      ];
    },

    customArticleFilter(item, queryText, itemText) {
      const text = (itemText || "").toString().toLowerCase();
      const query = (queryText || "").toString().toLowerCase().trim();

      if (!query) return true;

      const itemId = (item && (item.Id || item.id) ? String(item.Id || item.id) : "").toLowerCase();

      return text.includes(query) || itemId.includes(query);
    },
    async bootstrap() {
      // Cargar datos mock desde el servicio
      this.divisions = await TraceabilityService.getDivisions();
      this.articles = await TraceabilityService.getArticles(this.form.divisionId);
      this.people = await TraceabilityService.getPeople();
    },
    async onDivisionChange() {
      this.form.articleId = null;
      this.ingredients = [];

      this.articles = await TraceabilityService.getArticles(
        this.form.divisionId
      );
    },
    async onArticleChange() {
      if (this.loadingTraceability) return;
      
      if (!this.form.articleId) {
        this.ingredients = [];
        return;
      }
      this.loadingIngredients = true;
      try {
        this.ingredients = await TraceabilityService.getIngredientsByArticle(this.form.articleId);
      } finally {
        this.loadingIngredients = false;
      }
    },
    // prefillRecipeQty() {
    //   this.ingredients = this.ingredients.map(i => ({ ...i, UsedQty: i.RecipeQty }));
    // },
    // prefillRecipeQty() {
    //   const total = Number(this.form.totalQty);

    //   if (!total) {
    //     this.$toast && this.$toast.error
    //       ? this.$toast.error("Introduce la cantidad total encajada primero")
    //       : alert("Introduce la cantidad total encajada primero");
    //     return;
    //   }

    //   this.ingredients = this.ingredients.map(i => ({
    //     ...i,
    //     UsedQty: i.RecipeQty != null
    //       ? Number(i.RecipeQty) * total
    //       : null
    //   }));
    // },

    prefillRecipeQty() {
      const total = Number(this.form.totalQty);

      if (!total) {
        this.$toast && this.$toast.error
          ? this.$toast.error("Introduce la cantidad total encajada primero")
          : alert("Introduce la cantidad total encajada primero");
        return;
      }

      this.ingredients = this.ingredients.map(i => {
        const yaTieneCantidad =
          i.UsedQty !== null &&
          i.UsedQty !== undefined &&
          i.UsedQty !== "";

        return {
          ...i,
          UsedQty: yaTieneCantidad
            ? i.UsedQty
            : i.RecipeQty != null
              ? Number((Number(i.RecipeQty) * total).toFixed(3))
              : null
        };
      });
    },
    clearUsedQty() {
      this.ingredients = this.ingredients.map(i => ({ ...i, UsedQty: null }));
    },
    formatNumber(n) {
      if (n === null || n === undefined || n === "") return "";
      return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 3 }).format(Number(n));
    },
    onReset() {
      this.$refs.form.reset();
      this.ingredients = [];
      this.form.date = new Date().toISOString().substr(0, 10);
      this.form.montadasNataUno = 0;
      this.form.montadasNataDos = 0;
      this.form.masadas = "";
      this.form.plastones = "";
      this.form.polares = "";
      this.form.estado = "EN_CURSO";
      this.resetControles();
    },
    comprobarPolares(valor) {
      if (valor != null && valor > 24) {
        this.dialogPolares = true;
      }
    },
    onExit() {
      if (this.ingredients.some(i => i.UsedQty || i.Batch) || this.form.batch || this.form.totalQty) {
        if (!confirm("Tienes cambios sin guardar. ¿Seguro que quieres salir?")) {
          return;
        }
      }

      this.$router.push({ name: "TrazabilidadObradorListado" });
    },
    
    async onSubmit(estado = "EN_CURSO") {

      if (this.formularioBloqueado) {
        this.$toast && this.$toast.error
          ? this.$toast.error("Esta trazabilidad está finalizada y no se puede modificar")
          : alert("Esta trazabilidad está finalizada y no se puede modificar");
        return;
      }

       const formOk = this.$refs.form.validate();

        if (!formOk) {
          alert("Revisa los campos obligatorios marcados en rojo");
          return;
        }

      //if (!this.$refs.form.validate()) return;

      //if (!this.$refs.form.validate()) return;

      // const missingQty = this.ingredients.some(i =>
      //   i.UsedQty === null || i.UsedQty === undefined || i.UsedQty === ""
      // );

      // if (missingQty) {
      //   this.$toast && this.$toast.error
      //     ? this.$toast.error("Rellena todas las cantidades usadas")
      //     : alert("Rellena todas las cantidades usadas");
      //   return;
      // }

      if (estado === "FINALIZADO") {
        if (!this.form.batch || !this.form.batch.trim()) {
          this.$toast && this.$toast.error
            ? this.$toast.error("Para finalizar debes informar el lote final")
            : alert("Para finalizar debes informar el lote final");
          return;
        }

        if (this.form.totalQty === null || this.form.totalQty === undefined || this.form.totalQty === "") {
          this.$toast && this.$toast.error
            ? this.$toast.error("Para finalizar debes informar la cantidad total encajada")
            : alert("Para finalizar debes informar la cantidad total encajada");
          return;
        }

        const missingQty = this.ingredients.some(i =>
          i.UsedQty === null || i.UsedQty === undefined || i.UsedQty === ""
        );

        if (missingQty) {
          this.$toast && this.$toast.error
            ? this.$toast.error("Para finalizar debes rellenar todas las cantidades usadas")
            : alert("Para finalizar debes rellenar todas las cantidades usadas");
          return;
        }

        const missingIngredientLots = this.ingredients.some(i =>
          !i.Batch || !i.Batch.trim()
        );

        if (missingIngredientLots) {
          this.$toast && this.$toast.error
            ? this.$toast.error("Para finalizar debes rellenar todos los lotes de ingredientes")
            : alert("Para finalizar debes rellenar todos los lotes de ingredientes");
          return;
        }
      }

      const payload = {
        trazabilidadObradorId: this.isEdit ? Number(this.traceabilityId) : 0,
        articleId: this.form.articleId,
        operatorId: this.form.operatorId,
        operatorId2: this.form.operatorId,
        batch: this.form.batch,
        date: this.form.date,
        totalQty: this.form.totalQty === null ||
          this.form.totalQty === undefined ||
          this.form.totalQty === ""
          ? 0
          : Number(this.form.totalQty),
        notes: this.form.notes,
        montadasNataUno: this.form.montadasNataUno,
        montadasNataDos: this.form.montadasNataDos,
        masadas: this.form.masadas,
        plastones: this.form.plastones,
        polares: this.form.polares,
        estado: estado,
        controles: this.controles.map(x => ({
          fila: x.fila,
          polaresInicio: x.polaresInicio,
          polaresFinal: x.polaresFinal,
          cambioAceite: x.cambioAceite
        })),
        ingredients: this.ingredients.map(i => ({
          id: i.Id,
          name: i.Name,
          unit: i.Unit,
          recipeQty: i.RecipeQty,
          usedQty: i.UsedQty === null || i.UsedQty === undefined || i.UsedQty === ""
          ? 0
          : Number(i.UsedQty),
          batch: i.Batch && i.Batch.trim()
            ? i.Batch
            : "",
        }))
      };

      this.submitting = true;
      try {

        await (this.isEdit
      ? TraceabilityService.updateTraceability(payload, this.urlRaiz)
      : TraceabilityService.saveTraceability(payload, this.urlRaiz));

        //   const res = this.isEdit
        // ? await TraceabilityService.updateTraceability(payload, this.urlRaiz)
        // : await TraceabilityService.saveTraceability(payload, this.urlRaiz);

      this.$toast && this.$toast.success
        ? this.$toast.success(this.isEdit ? "Trazabilidad actualizada correctamente" : "Trazabilidad guardada correctamente")
        : alert(this.isEdit ? "Trazabilidad actualizada correctamente" : "Trazabilidad guardada correctamente");


        // this.$toast && this.$toast.success
        //   ? this.$toast.success("Trazabilidad guardada correctamente")
        //   : alert("Trazabilidad guardada correctamente");

        // this.lastPayload = JSON.stringify(res.data, null, 2);
        // this.dialog = true;

        this.$router.push({ name: "TrazabilidadObradorListado" });
      } catch (e) {

        console.error(e);
        this.$toast && this.$toast.error
        ? this.$toast.error(this.isEdit ? "Error al actualizar la trazabilidad" : "Error al guardar la trazabilidad")
        : alert(this.isEdit ? "Error al actualizar la trazabilidad" : "Error al guardar la trazabilidad");
    
      } finally {
        this.submitting = false;
      }
    },
    // async loadTraceability() {
    //   if (!this.traceabilityId) return;

    //   this.submitting = true;
    //   try {
    //     const data = await TraceabilityService.getTraceability(this.traceabilityId, this.urlRaiz);

    //     this.form.articleId = data.articleId || data.ArticleId;
    //     this.form.operatorId = data.operatorId || data.OperatorId;
    //     this.form.batch = data.batch || data.Batch;
    //     this.form.date = data.date || data.Date;
    //     this.form.totalQty = data.totalQty || data.TotalQty;
    //     this.form.notes = data.notes || data.Notes || "";

    //     this.ingredients = (data.ingredients || data.Ingredients || []).map(i => ({
    //       id: i.id ?? i.Id,
    //       name: i.name ?? i.Name,
    //       unit: i.unit ?? i.Unit ?? "",
    //       recipeQty: i.recipeQty ?? i.RecipeQty,
    //       usedQty: i.usedQty ?? i.UsedQty,
    //       batch: i.batch ?? i.Batch ?? "",
    //       step: i.step ?? i.Step
    //     }));
    //   } catch (e) {
    //     console.error(e);
    //     this.$toast && this.$toast.error
    //       ? this.$toast.error("Error al cargar la trazabilidad")
    //       : alert("Error al cargar la trazabilidad");
    //   } finally {
    //     this.submitting = false;
    //   }
    // }
    async loadTraceability() {
      if (!this.traceabilityId) return;

      this.submitting = true;
      this.loadingTraceability = true;

      try {
        const data = await TraceabilityService.getTraceability(this.traceabilityId, this.urlRaiz);

        const articleId = data.articleId ?? data.ArticleId;
        const operatorId = data.operatorId ?? data.OperatorId;
        const operatorId2 = data.operatorId ?? data.OperatorId;
        const batch = data.batch ?? data.Batch;
        const date = data.date ?? data.Date;
        const totalQty = data.totalQty ?? data.TotalQty;
        const notes = data.notes ?? data.Notes ?? "";
        const savedIngredients = (data.ingredients ?? data.Ingredients ?? []).map(i => ({
          id: i.id ?? i.Id,
          name: i.name ?? i.Name ?? "",
          unit: i.unit ?? i.Unit ?? "",
          recipeQty: i.recipeQty ?? i.RecipeQty,
          usedQty: i.usedQty ?? i.UsedQty,
          batch: i.batch ?? i.Batch ?? "",
          step: i.step ?? i.Step,
          order: i.order ?? i.Order
        }));

        this.form.articleId = articleId;
        this.form.operatorId = operatorId;
        this.form.operatorId2 = operatorId2;
        this.form.batch = batch;
        this.form.date = date;
        this.form.totalQty = totalQty;
        this.form.notes = notes;
        this.form.montadasNataUno = data.MontadasNataUno ?? data.montadasNataUno ?? 0;
        this.form.montadasNataDos = data.MontadasNataDos ?? data.montadasNataDos ?? 0;
        this.form.masadas = data.Masadas ?? data.masadas ?? "";
        this.form.plastones = data.Plastones ?? data.plastones ?? "";
        this.form.polares = data.Polares ?? data.polares ?? "";
        this.form.estado = data.Estado ?? data.estado ?? "EN_CURSO";

        // Cargamos receta base desde Ekon
        const recipeIngredients = await TraceabilityService.getIngredientsByArticle(articleId);

        // Diccionario con lo guardado
        const savedMap = {};
        savedIngredients.forEach(i => {
          savedMap[String(i.id ?? i.Id)] = i;
        });

        // Fusionamos receta base + valores guardados
        this.ingredients = recipeIngredients.map(recipeIng => {
          const saved = savedMap[String(recipeIng.Id ?? recipeIng.id)];
          return {
              Id: recipeIng.Id ?? recipeIng.id,
              Name: recipeIng.Name ?? recipeIng.name,
              Unit: recipeIng.Unit ?? recipeIng.unit,
              RecipeQty: recipeIng.RecipeQty ?? recipeIng.recipeQty,
              UsedQty: saved ? (saved.usedQty ?? saved.UsedQty ?? null) : null,
              Batch: saved ? (saved.batch ?? saved.Batch ?? "") : "",
              Step: recipeIng.Step ?? recipeIng.step,
              Order: recipeIng.Order ?? recipeIng.order,
              UnidadPrincipal: recipeIng.UnidadPrincipal ?? recipeIng.unidadPrincipal,
            };
        });

        if (["FINALIZADO", "ARCHIVADO"].includes(this.form.estado)) {
          this.ingredients = this.ingredients.filter(i => Number(i.UsedQty) !== 0);
        }

        // Por si hay líneas antiguas guardadas que ya no estén en la receta actual,
        // las añadimos al final para no perder información
        const recipeIds = this.ingredients.map(x => String(x.Id));
        const missingSaved = savedIngredients.filter(x => !recipeIds.includes(String(x.id ?? x.Id)));

        if (missingSaved.length) {
          this.ingredients = this.ingredients.concat(
            missingSaved.map(i => ({
              Id: i.id ?? i.Id,
              Name: i.name || "(Ingrediente no encontrado en receta actual)",
              UnidadPrincipal: i.unidadPrincipal ?? i.UnidadPrincipal ?? "",
              Unit: i.unit || "",
              RecipeQty: i.recipeQty ?? null,
              UsedQty: i.usedQty,
              Batch: i.batch || "",
              Step: i.step,
              Order: i.order
            }))
          );
        }

        const controlesBack = data.Controles ?? data.controles ?? [];

        if (controlesBack.length) {
          this.controles = controlesBack.map(c => ({
            fila: c.Fila ?? c.fila,
            polaresInicio: c.PolaresInicio ?? c.polaresInicio ?? null,
            polaresFinal: c.PolaresFinal ?? c.polaresFinal ?? null,
            cambioAceite: c.CambioAceite ?? c.cambioAceite ?? false
          }));
        } else {
          this.resetControles();
        }

      } catch (e) {
        console.error(e);
        this.$toast && this.$toast.error
          ? this.$toast.error("Error al cargar la trazabilidad")
          : alert("Error al cargar la trazabilidad");
      } finally {
        this.loadingTraceability = false;
        this.submitting = false;
      }
    }
  },
  async created() {
    this.resetControles();
    await this.bootstrap();
    if (this.isEdit) {
      await this.loadTraceability();
    }
  }
};
</script>

<style scoped>
.sticky-footer {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 3;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 -6px 18px rgba(0,0,0,0.06);
}
.btn-lg {
  height: 52px !important;
  font-size: 1.05rem !important;
}
.payload-pre {
  background: #f6f8fa;
  border-radius: 12px;
  padding: 12px;
  max-height: 300px;
  overflow: auto;
}
/* Mejoras táctiles */
.v-input input[type="number"] {
  font-size: 16px; /* evita zoom en iPad/iOS */
}

.action-buttons {
  row-gap: 8px;
}

.trace-btn {
  min-height: 48px;
  font-size: 1rem;
  white-space: normal !important;
  line-height: 1.2;
  padding: 8px 12px !important;
}

/* Tablet */
@media (max-width: 960px) {
  .trace-btn {
    font-size: 0.9rem;
    min-height: 46px;
  }
}

/* Tablet pequeña / móvil grande */
@media (max-width: 600px) {
  .trace-btn {
    font-size: 0.85rem;
    min-height: 44px;
  }
}

.action-buttons .v-col {
  padding-top: 4px;
  padding-bottom: 4px;
}

.action-buttons {
  row-gap: 10px;
}

.check-bar {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 6px;
}

.check-item {
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
  background: #f0f0f0;
  cursor: pointer;
  font-size: 0.85rem;
  user-select: none;
  transition: all 0.2s ease;
}

.check-item.active {
  background: #1976d2;
  color: white;
  font-weight: bold;
}

.check-item:hover {
  background: #d6e4ff;
}
</style>